<template>
  <div class="share-bill-receipt__wrapper">
    <base-popup
      class="share-bill-receipt"
      ref="popup"
      v-show="!notificationShowing"
      :without-icon="true"
    >
      <template #header="{ close }">
        <div class="share-bill-receipt__header">
          <div class="share-bill-receipt__title">
            {{ $t('bills.popup.share-bill-receipt.title') }}
          </div>
          <popup-close-button
            class="share-bill-receipt__close"
            @click="close"
          ></popup-close-button>
        </div>
      </template>
      <template #content>
        <div class="share-bill-receipt__input">
          <text-input
            v-model:value="email"
            :title="$t('bills.popup.share-bill-receipt.fields.email')"
            :placeholder="
              $t('bills.popup.share-bill-receipt.fields.email-placeholder')
            "
            :mask="$options.EMAIL_MAKS"
          ></text-input>
        </div>
      </template>
      <template #actions>
        <div class="share-bill-receipt__actions">
          <primary-button
            :disabled="receiptSending"
            class="share-bill-receipt__actions-item"
            :label="$t('bills.popup.share-bill-receipt.actions.send')"
            @click="shareReceipt"
          ></primary-button>
        </div>
      </template>
    </base-popup>
    <success-notification
      ref="billReceiptSharedNotification"
      :text="$t('bills.popup.share-bill-receipt.notifications.shared')"
    ></success-notification>
  </div>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PopupCloseButton from '@vue-app/components/base/button/PopupCloseButton.vue'
import SocialShareButtons from '@vue-app/components/base/share/SocialShareButtons.vue'
import LinkInput from '@vue-app/components/base/input/LinkInput.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import { Bill } from '@js-app/entities/Bill'
import TextInput from '@vue-app/components/base/input/TextInput.vue'

import { emailMask } from 'text-mask-addons/dist/emailMask'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import { mapState } from 'vuex'

export default {
  name: 'ShareBillReceiptPopup',
  components: {
    PrimaryButton,
    TextInput,
    SuccessNotification,
    LinkInput,
    SocialShareButtons,
    PopupCloseButton,
    BasePopup,
  },
  props: {
    bill: Bill,
  },

  data() {
    return {
      notificationShowing: false,
      email: '',
      receiptSending: false,
    }
  },

  computed: {
    ...mapState(['selectedCompany']),
  },

  EMAIL_MAKS: emailMask,

  methods: {
    open() {
      return this.$refs.popup.open()
    },
    async shareReceipt() {
      this.receiptSending = true

      try {
        await CompaniesApi.shareBillReceipt(
          this.selectedCompany,
          this.bill.operationId,
          this.email
        )
        this.notificationShowing = true
        await this.$refs.billReceiptSharedNotification.show()

        this.notificationShowing = false
      } catch (e) {
        alert('Error while sending receipt')
      } finally {
        this.receiptSending = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.share-bill-receipt {
  :deep(.popup) {
    width: 395px;
    padding: 30px 0 52px;

    .popup__actions {
      padding-left: 52px;
      padding-right: 52px;
    }
  }

  &__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    height: 30px;
    margin-bottom: 44px;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #585f6d;
  }

  &__close {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
  }

  &__buttons {
    padding: 0 70px;
  }

  &__input {
    margin-top: 60px;
    padding: 0 52px;
  }

  &__actions {
    &-item {
      padding: 25px;
    }
  }
}
</style>
